import { Spinner } from 'reactstrap'

export const Loader = () => (
  <div className="d-flex justify-content-center p-5">
    <Spinner color="primary" />
  </div>
)
